<template>
    <div>
        <div class="form-group">
            <label class="font-weight-bold">
                Paketgröße(n) auswählen
            </label>
            <div class="d-flex flex-column gap-2" :key="packageUpdates">
                <div v-for="(redirectPackage, i) in redirect.packages">
                    <SelectPackageDimensionPreset :store-uuid="store.id"
                                                  v-model="redirect.packages[i]"
                                                  :shipping-integration="IntegrationCodeEnum.GarantiertGeliefert"
                                                  :allow-deletion="redirect.packages.length > 1"
                                                  :overwrite-presets="packagePresets"
                                                  solid
                                                  @delete="deletePackage(i)"
                    />
                </div>
                <div>
                    <button class="btn btn-light-gg" @click="addPackage">
                        <i class="fas fa-plus-square"/>
                        {{ __('actions.add_thing', {thing: __('orders.package')}) }}
                    </button>
                </div>
            </div>
            <div class="form-text text-muted">
                Wählen Sie eine oder mehrere Paketgrößen zum Versenden der Ware.
            </div>
        </div>
        <div class="form-group">
            <label class="font-weight-bold">
                Gekühlte Ware
            </label>
            <select class="form-control form-control-solid" v-model="redirect.cooling_level">
                <option v-for="coolingLevelId of GarantiertGeliefertCoolingLevel"
                        :value="coolingLevelId"
                >
                    {{ __('integrations.gg.cooling.' + coolingLevelId) }}
                </option>
            </select>
            <div class="form-text text-muted">
                Bitte wählen Sie aus, ob Sie gekühlte Waren versenden.
            </div>
        </div>
        <div>
            <button class="btn btn-gg"
                    @click="openSelectDriver"
                    :disabled="!dimensionsAreValid"
            >
                <i class="fas fa-truck-moving"/>
                Fahrt suchen auf <span style="text-decoration: underline;">garantiert-geliefert.de</span>
            </button>
            <div class="form-text text-muted font-size-xs mt-2 w-50">
                Nach dem klick auf "Select driver" öffnet sich ein neues Fenster in dem Sie eine Fahrt für die Ware
                auswählen.
            </div>
        </div>
    </div>
</template>

<script>
import Checkbox from "@components/Form/Checkbox.vue";
import SelectPackageDimensionPreset from "@components/Packages/SelectPackageDimensionPreset.vue";
import {IntegrationCodeEnum} from "@generated/integrationCodeEnum";
import {GarantiertGeliefertCoolingLevel} from "@generated/garantiertGeliefertCoolingLevel";
import {Ajax} from "@js/api/ajax";

const emptyPackage = {
    id: null,
    name: '',
    dimensions: {
        width: {
            value: 0.0,
            unit: 'cm'
        },
        height: {
            value: 0.0,
            unit: 'cm'
        },
        length: {
            value: 0.0,
            unit: 'cm'
        },
    }
};

export default {
    components: {Checkbox, SelectPackageDimensionPreset},

    props: {
        order: Object,
        store: Object,
    },

    data() {
        return {
            packageUpdates: 0,
            packagePresets: {},
            redirect: this.$inertia.form({
                packages: [emptyPackage],
                cooling_level: 0,
            })
        }
    },

    mounted() {
        Ajax.Packages.getPresets(this.store.id, this.order.integration.code)
            .then(response => this.packagePresets = response.data);
    },

    methods: {
        openSelectDriver() {
            window.open(this.redirectUrl, '_blank').focus();
        },

        addPackage() {
            this.redirect.packages.push(emptyPackage);
        },

        deletePackage(packageIndex) {
            let removedPackage = this.redirect.packages.splice(packageIndex, 1);
            this.packageUpdates++;

            logDev('Removed order package at index ' + packageIndex, removedPackage);
        }
    },

    computed: {
        GarantiertGeliefertCoolingLevel() {
            return GarantiertGeliefertCoolingLevel
        },

        IntegrationCodeEnum() {
            return IntegrationCodeEnum
        },

        redirectUrl() {
            return this.$route('GG.redirect', {
                orderCode: this.order.url_key,
                packages: this.redirect.packages.filter(orderPackage => orderPackage.id !== null),
                cooling_level: this.redirect.cooling_level,
            });
        },

        dimensionsAreValid() {
            for (let orderPackage of this.redirect.packages) {
                if (orderPackage.id === null) {
                    continue;
                }

                let dimensions = orderPackage.dimensions;

                if (dimensions === undefined || dimensions == null) {
                    return false;
                }

                let isValid = dimensions.width.value > 0
                    && dimensions.height.value > 0
                    && dimensions.length.value > 0;

                if (!isValid) {
                    return false;
                }
            }

            return true;
        }
    }
}
</script>
